// English
export default {
  newVersionAvailable: 'New version available',
  versionInfo: 'A new version of {appName} is available. Please reload the page to update to version {version}.',
  reload: 'Reload',
  later: 'Later',
};
